import axios from 'axios';
import { PRISM_API_BASE_URL } from '../constants/constants';

// Without a timeout, a hung backend request (e.g. an unresponsive downstream call, or
// the API Gateway integration itself timing out) leaves the UI spinning indefinitely
// instead of failing with a message the user can act on. 35s sits just above the ~29-30s
// hard ceiling API Gateway enforces on the backend, so the backend's own error (a clean
// JSON response, or its own timeout) reaches the user first; this is the last-resort net.
export default axios.create({
  baseURL: PRISM_API_BASE_URL,
  timeout: 35000
});
